module.exports = __webpack_public_path__ + "img/image2.af286f0f.jpg";